<template>
    <div class="section-box">
        <el-row type="flex" class="row-bg" justify="end" v-if="!(typeof(actionData.systemcdgl_add) != 'undefined'&&!actionData.systemcdgl_add)">
            <el-col :span="24" style="text-align: right;">
                <el-button size="medium" type="primary" icon="el-icon-plus" @click="onAddFunction">添加</el-button>
            </el-col>
        </el-row>
        <el-form inline label-width="90px">
            <el-form-item label="菜单名称：">
                <el-input size="medium" placeholder="请输入菜单名称" v-model="form.MenuName" type="text" />
            </el-form-item>
            <el-form-item label="是否可见：">
                <el-select size="medium" v-model="form.Status">
                    <el-option :value="0" label="全部"></el-option>
                    <el-option :value="1" label="可见"></el-option>
                    <el-option :value="2" label="不可见"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-form-item>
        </el-form>

         <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%;margin-top: 20px;"
            height="590"
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="菜单编号" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.MenuID || '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="菜单代码" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.MenuCode || '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="菜单名称" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.MenuName || '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="菜单地址" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.MenuUrl || '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="是否可见" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.IsVisible == 1?'可见':'不可见'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="父菜单" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.ParentMenuName || '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="备注" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.Remark || '--'}}</span>
                </template>
            </el-table-column>


            <el-table-column label="操作">
                <template slot-scope="scope">
                    <template v-if="!(typeof(actionData.systemcdgl_edit) != 'undefined'&&!actionData.systemcdgl_edit)">
                        <el-button size="mini" type="primary" @click="onEditFunction(scope.row)">编辑</el-button>
                    </template>
                    <template v-if="!(typeof(actionData.systemcdgl_delete) != 'undefined'&&!actionData.systemcdgl_delete)">
                        <el-button size="mini" type="danger" @click="deleteAdminMenuFunction(scope.row.MenuID)">删除</el-button>
                    </template>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageNum"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="30%"
        >
            <el-form label-width="120px">
                <el-form-item label="菜单名称：" required>
                    <el-input size="medium" placeholder="请输入菜单名称" v-model="infoForm.MenuName" type="text" />
                </el-form-item>
                <el-form-item label="菜单代码：" required>
                    <el-input size="medium" placeholder="请输入菜单代码" v-model="infoForm.MenuCode" type="text" />
                </el-form-item>
                <el-form-item label="菜单地址：" required>
                    <el-input size="medium" placeholder="请选择" v-model="infoForm.MenuUrl" type="text" />
                </el-form-item>
                <el-form-item label="父级菜单：" >
                    <el-select placeholder="请选择菜单" size="medium" filterable v-model="infoForm.ParentID" style="width: 100%">
                        <el-option 
                            v-for="(item,index) in menuList" 
                            :label="item.MenuName" 
                            :value="item.MenuId" 
                            :key="index"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否可见：">
                    <el-radio-group v-model="infoForm.IsVisible">
                        <el-radio :label="1">可见</el-radio>
                        <el-radio :label="0">不可见</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注：" >
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 4}"
                        placeholder="请输入内容"
                        v-model="infoForm.Remark">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="medium" @click="confirmSetFunction()" :loading="confirmLoading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {
        getMenuList,                //获取菜单列表
        menuListData,               //获取菜单列表 在dialog里
        addAdminMenu,               //添加菜单
        updateAdminMenu,            //编辑
        deleteAdminMenu,            //删除菜单
    } from "@/service/system";
    import { getActionData } from '@/utils/store'
    export default {
        data() {
            return {
                actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
                dialogTitle: '添加或编辑',
                dialogVisible: false,
                listLoading: false,
                confirmLoading: false,
                form: {
                    PageNum: 1,
                    PageSize: 10,
                    MenuName: '',
                    Status: 0,
                },
                searchData:{},
                oraginForm:{},
                total: 0,                       //总条数
                tableData:[],
                infoForm: {
                    MenuID: '',                 //菜单ID编辑的时候用

                    MenuName: '',               //菜单名称
                    MenuCode: '',               //菜单代码
                    MenuUrl: '',                //菜单跳转地址
                    ParentID: 0,               //父级菜单id
                    IsVisible: 1,              //是否可见
                    Remark: '',                 //备注
                },
                oraginInfoForm: {},
                menuList:[],                    //dialog 菜单
            };
        },
        activated(){
            this.handleSearch()
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.oraginInfoForm = JSON.parse(JSON.stringify(this.infoForm))
            this.tableData = [];
        },
        methods: {
            // 查询
            handleSearch() {
                this.searchData = Object.assign({}, this.form)
                this.handleCurrentChange(1)
            },
            // 重置
            handleReset() {
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.PageNum = 1
                this.form.PageSize = val
                this.searchData.PageNum = 1
                this.searchData.PageSize = val
                this.GetMenuListFun()
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.PageNum = val
                this.searchData.PageNum = val
                this.GetMenuListFun()
            },
            //获取菜单列表
            async GetMenuListFun(){
                this.listLoading = true
                let data = JSON.parse(JSON.stringify(this.searchData))
                !data.MenuName && delete data.MenuName
                data.AppId = 1
                data.platform = 'pcweb'
                let res = await getMenuList(data)
                this.listLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.MenuList
                this.total = res.Data.TotalCount
            },
            //点击添加或编辑
            onAddFunction(){
                this.dialogTitle = '添加'
                this.dialogVisible = true;
                this.GetmenuListData();
                this.infoForm = JSON.parse(JSON.stringify(this.oraginInfoForm))
            },
            // 获取dialog菜单列表
            async GetmenuListData(){
                let data = {}
                data.AppId = 1;
                data.platform = 'pcweb'
                let res = await menuListData(data)
                this.menuList = res.Data.MenuList
            },
            //dialog 确定提交
            confirmSetFunction(){
                let data = Object.assign({}, this.infoForm)
                if(!data.MenuName) {
                    return this.$message.warning('请输入菜单名称')
                }
                if(!data.MenuCode) {
                    return this.$message.warning('请输入菜单代码')
                }
                if(!data.MenuUrl) {
                    return this.$message.warning('请选择菜单地址')
                }
                data.platform = 'pcweb'
                this.confirmLoading = true
                if(!data.MenuID) {
                    !data.MenuID && delete data.MenuID
                    data.AppId = 1
                    addAdminMenu(data).then(res=> {
                        this.confirmLoading = false
                        if(res.Result != 1) {
                            return this.$message.error(res.Message)
                        }
                        this.$message.success(res.Message)
                        this.dialogVisible = false
                        this.GetMenuListFun();
                    })
                }else{
                    updateAdminMenu(data).then(res=> {
                        this.confirmLoading = false
                        if(res.Result != 1) {
                            return this.$message.error(res.Message)
                        }
                        this.$message.success(res.Message)
                        this.dialogVisible = false
                        this.GetMenuListFun();
                    })
                }
            },
            // 点击list 编辑
            onEditFunction(row){
                let infoForm = JSON.parse(JSON.stringify(row))
                this.dialogTitle = '编辑'
                this.dialogVisible = true;
                this.GetmenuListData();
                this.$nextTick(()=>{
                    this.infoForm = infoForm
                })
            },

            // 删除功能列表
            deleteAdminMenuFunction(id){
                let data = {}
                data.MenuID = id
                data.platform = 'pcweb'
                deleteAdminMenu(data).then(res=>{
                    if(res.Result !=1 ) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success(res.Message)
                    this.GetMenuListFun();
                })
            },
        }
    };
</script>
<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
</style>